<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <Traders type="traders"></Traders>
        </div>
      </div>
    </div>


    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import Traders from "@/components/users/Traders.vue";
import Users from "@/components/users/Users.vue";
import {UserRole} from "@/models/enum/UserRole";

const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  components: {
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
    Traders,
    Users
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const state = reactive({
    });


    onMounted(() => {
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      loader,
      dateHelper,
      numberFormatter,
      confirmModal,
      helper,
      UserRole,
    }
  }
})
</script>
